import { connect } from "react-redux";

import { getAlerts, getGraphData } from "../../store/videogrid/duck";
import ChannelSummaryComponent from "./component";

const ChannelSummaryContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {
    getGraphData,
    getAlerts,
  },
)(ChannelSummaryComponent);

export default ChannelSummaryContainer;
